import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, type Auth } from 'firebase/auth'

let authInstance: Auth | null = null

// Not initialized in development — see main.tsx's bootstrap(), which skips
// this entirely so the app can be used locally without live Firebase config.
export function initFirebaseAuth(config: Record<string, string>): Auth {
  const app = initializeApp(config)
  authInstance = getAuth(app)
  return authInstance
}

export function getFirebaseAuth(): Auth | null {
  return authInstance
}

export const googleProvider = new GoogleAuthProvider()
// Server-side (server/src/routes/admin.ts) is the actual enforcement point —
// this only steers Google's account picker, a user could still pick a
// different account if they typed the URL directly.
googleProvider.setCustomParameters({ hd: 'selciuspartners.com' })
